webpackJsonp([6,43,46],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isInitialized: false,
      isRequesting: false,
      dialogErrorVisible: false,
      error: {
        title: '',
        message: ''
      }
    };
  },

  computed: {
    post: {
      get: function get() {
        return this.$store.getters['wordpress/posts/selected'];
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    page: {
      get: function get() {
        return this.$store.getters['wordpress/pages/selected'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    }
  },
  methods: {
    /**
     * コンポーネント名をIDから取得
     */
    getComponentNameById: function getComponentNameById(id) {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id] ? __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id].meta.name : null;
    },

    /**
     * コンポーネントのメタ情報をIDから取得
     */
    getComponentMetaById: function getComponentMetaById(id) {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id] ? __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id].meta : null;
    },

    /**
     * pageをWP APIに問い合わせる
     */
    // requestPage: async function (id) {
    //   if (this.page) return Promise.resolve(this.page)
    //   const response = await this.$store.dispatch('wordpress/getPage', id)
    //   if (response.error) {
    //     this.error.title = `${response.code} Error: ${response.status}`
    //     this.error.message = `固定ページ読み込み時の${response.message}`
    //     this.dialogErrorVisible = true
    //     this.isRequesting = false
    //   }
    //   return Promise.resolve(response)
    // },

    /**
     * postsをWP APIに問い合わせる
     */
    requestPosts: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(_this.posts.length > 0)) {
                              _context.next = 3;
                              break;
                            }

                            resolve(_this.posts);
                            return _context.abrupt('return', true);

                          case 3:
                            _context.next = 5;
                            return _this.$store.dispatch('wordpress/posts/fetch');

                          case 5:
                            response = _context.sent;

                            if (response.error) {
                              _this.$msgbox({
                                title: '投稿の読み込みに失敗しました',
                                message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                                confirmButtonText: 'OK'
                              });
                              _this.isRequesting = false;
                              reject(response.error);
                            }
                            resolve(response);

                          case 8:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x, _x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function requestPosts() {
        return _ref.apply(this, arguments);
      }

      return requestPosts;
    }(),

    /**
     * pagesをWP APIに問い合わせる
     */
    requestPages: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(_this2.pages.length > 0)) {
                              _context3.next = 3;
                              break;
                            }

                            resolve(_this2.pages);
                            return _context3.abrupt('return', true);

                          case 3:
                            _context3.next = 5;
                            return _this2.$store.dispatch('wordpress/pages/fetch');

                          case 5:
                            response = _context3.sent;

                            if (response.error) {
                              _this2.$msgbox({
                                title: '固定ページの読み込みに失敗しました',
                                message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                                confirmButtonText: 'OK'
                              });
                              _this2.isRequesting = false;
                              reject(response.error);
                            }
                            resolve(response);

                          case 8:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x3, _x4) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function requestPages() {
        return _ref3.apply(this, arguments);
      }

      return requestPages;
    }(),

    /**
     * mediaをWP APIに問い合わせる
     */
    requestMedia: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!(_this3.media.length > 0)) {
                              _context5.next = 3;
                              break;
                            }

                            resolve(_this3.media);
                            return _context5.abrupt('return', true);

                          case 3:
                            _context5.next = 5;
                            return _this3.$store.dispatch('wordpress/media/fetch');

                          case 5:
                            response = _context5.sent;

                            if (response.error) {
                              _this3.$msgbox({
                                title: 'アップロード画像の読み込みに失敗しました',
                                message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                                confirmButtonText: 'OK'
                              });
                              _this3.isRequesting = false;
                              reject(response.error);
                            }
                            resolve(response);

                          case 8:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x5, _x6) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function requestMedia() {
        return _ref5.apply(this, arguments);
      }

      return requestMedia;
    }(),

    /**
     * themesをWP APIに問い合わせる
     */
    requestThemes: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (!_this4.$store.getters['wordpress/status/isThemesLoaded']) {
                              _context7.next = 3;
                              break;
                            }

                            resolve(_this4.themes);
                            return _context7.abrupt('return', true);

                          case 3:
                            _context7.next = 5;
                            return _this4.$store.dispatch('wordpress/themes/fetch');

                          case 5:
                            response = _context7.sent;

                            if (!response.error) {
                              _context7.next = 11;
                              break;
                            }

                            _this4.$msgbox({
                              title: 'テーマデータの読み込みに失敗しました',
                              message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                              confirmButtonText: 'OK'
                            });
                            _this4.isRequesting = false;
                            reject(response.error);
                            return _context7.abrupt('return', false);

                          case 11:
                            _this4.$store.commit('wordpress/status/themesLoaded');
                            resolve(response);

                          case 13:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this4);
                  }));

                  return function (_x7, _x8) {
                    return _ref8.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function requestThemes() {
        return _ref7.apply(this, arguments);
      }

      return requestThemes;
    }(),

    /**
     * settingsをWP APIに問い合わせる
     */
    requestSettings: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            if (!_this5.$store.getters['wordpress/status/isSettingsLoaded']) {
                              _context9.next = 3;
                              break;
                            }

                            resolve(_this5.settings);
                            return _context9.abrupt('return', true);

                          case 3:
                            _context9.next = 5;
                            return _this5.$store.dispatch('wordpress/settings/fetch');

                          case 5:
                            response = _context9.sent;

                            if (!response.error) {
                              _context9.next = 11;
                              break;
                            }

                            _this5.$msgbox({
                              title: '設定データの読み込みに失敗しました',
                              message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                              confirmButtonText: 'OK'
                            });
                            _this5.isRequesting = false;
                            reject(response.error);
                            return _context9.abrupt('return', false);

                          case 11:
                            _this5.$store.commit('wordpress/status/settingsLoaded');
                            resolve(response);

                          case 13:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this5);
                  }));

                  return function (_x9, _x10) {
                    return _ref10.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function requestSettings() {
        return _ref9.apply(this, arguments);
      }

      return requestSettings;
    }(),

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getCssColorsValue: function getCssColorsValue(type) {
      return 'rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': ' + this.getCssColorsValue(type);
    },

    /**
     * テーマカラー用のCSSを用意する
     */
    getCssForThemeColors: function getCssForThemeColors() {
      var _this6 = this;

      return ['base', 'main', 'accent'].reduce(function (curr, type) {
        return curr + ('.theme-' + type + '-color {' + _this6.getThemeInlineStyle('color', type) + '}.theme-' + type + '-color-hover:hover {' + _this6.getThemeInlineStyle('color', type) + '}.theme-' + type + '-bg-color {' + _this6.getThemeInlineStyle('background-color', type) + '}.theme-' + type + '-bg-color-hover:hover {color: #fff; ' + _this6.getThemeInlineStyle('background-color', type) + '}.theme-' + type + '-border-color {' + _this6.getThemeInlineStyle('border-color', type) + '}.theme-' + type + '-fill-color {' + _this6.getThemeInlineStyle('fill', type) + '}');
      }, '');
    },

    /**
     * テーマカラー用のCSSをhead要素内のstyle要素に注入する
     */
    injectThemeColorsStyle: function injectThemeColorsStyle() {
      var head = document.head;
      var style = document.createElement('style');
      style.type = 'text/css';
      if (style.styleSheet) {
        style.styleSheet.cssText = this.getCssForThemeColors();
      } else {
        style.appendChild(document.createTextNode(this.getCssForThemeColors()));
      }
      head.appendChild(style);
    }
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectImage_vue__ = __webpack_require__(458);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28312d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectImage_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28312d60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28312d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'select-image',
  props: ['value'],
  data: function data() {
    return {
      selected: { id: 0 }
    };
  },
  // watch: {
  //   /**
  //    * @see https://stackoverflow.com/questions/40915436/vuejs-update-parent-data-from-child-component/40915910
  //    */
  //   selected: function (newVal, oldVal) {
  //     console.log('%cnewValue = ' + JSON.stringify(newVal), 'color:red')
  //     console.log('%coldValue = ' + JSON.stringify(oldVal), 'color:red')
  //     this.selected.id = newVal.id
  //     this.$emit('input', this.selected)
  //   }
  // },
  computed: {
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    }
  },
  created: function created() {
    if (false) console.log('On SelectImage created...');
    // if (process.env.NODE_ENV !== 'production') console.log(this.media)
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.id))
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.media_details.sizes.thumbnail))

    this.selected = this.value;
  }
});

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("b7ba9072", content, true, {});

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".image[data-v-28312d60]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.image-list[data-v-28312d60]{border:1px solid #ddd;height:180px;min-height:50vh;overflow:scroll}.image-item-input[data-v-28312d60]{display:none}.image-item-input:checked+.image-item-label[data-v-28312d60]:after{border:3px solid #569cf3}.image-item-label[data-v-28312d60]{display:block;width:139px;height:139px;position:relative}.image-item-label[data-v-28312d60]:after{content:\"\";display:block;width:100%;height:100%;position:absolute;top:0;left:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/app/SelectImage.vue"],"names":[],"mappings":"AAsBA,wBACE,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,gBAAkB,CACtB,AACD,6BACI,sBAAuB,AACvB,aAAc,AACd,gBAAiB,AACjB,eAAiB,CACpB,AACD,mCACI,YAAc,CACjB,AACD,mEACM,wBAA0B,CAC/B,AACD,mCACI,cAAe,AACf,YAAa,AACb,aAAc,AACd,iBAAmB,CACtB,AACD,yCACM,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACb","file":"SelectImage.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.image[data-v-28312d60] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.image-list[data-v-28312d60] {\n    border: 1px solid #ddd;\n    height: 180px;\n    min-height: 50vh;\n    overflow: scroll;\n}\n.image-item-input[data-v-28312d60] {\n    display: none;\n}\n.image-item-input:checked + .image-item-label[data-v-28312d60]:after {\n      border: 3px solid #569cf3;\n}\n.image-item-label[data-v-28312d60] {\n    display: block;\n    width: 139px;\n    height: 139px;\n    position: relative;\n}\n.image-item-label[data-v-28312d60]:after {\n      content: \"\";\n      display: block;\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.media)?[_c('ul',{staticClass:"image-list flex wrap"},[_vm._l((_vm.media),function(image,index){return [_c('li',{key:index,staticClass:"image-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.id),expression:"selected.id"}],staticClass:"image-item-input",attrs:{"type":"radio","id":_vm._uid + '-' + image.id},domProps:{"value":image.id,"checked":_vm._q(_vm.selected.id,image.id)},on:{"change":function($event){_vm.$set(_vm.selected, "id", image.id)}}}),_vm._v(" "),_c('label',{staticClass:"image-item-label",attrs:{"for":_vm._uid + '-' + image.id}},[_c('img',{staticClass:"image",attrs:{"src":image.media_details.sizes.thumbnail.source_url}})])])]})],2)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_RouteBase__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_SelectImage__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(26);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_RouteBase__["default"]],
  components: {
    'select-image': __WEBPACK_IMPORTED_MODULE_4__components_app_SelectImage__["default"]
  },
  data: function data() {
    return {
      checked: false,
      defaultSettings: __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].settings,
      selectedImage: {
        key: null,
        subKey: null,
        id: 0
      },
      dialogFormVisible: false
    };
  },
  computed: {},
  methods: {
    /**
     * 「画像の選択」ボタンをクリックした場合にselectedImageに対応するプロパティを入れる
     */
    onSelectImage: function onSelectImage(key, subKey, image) {
      this.selectedImage.key = key;
      this.selectedImage.subKey = subKey;
      this.selectedImage.id = image ? image.id : 0;
      this.dialogFormVisible = true;
    },
    /**
     * 画像選択のダイアログで選択ボタンをクリックした場合に、対応するプロパティに選んだ画像情報を入れる
     */
    onUpdateImage: function onUpdateImage() {
      var _this = this;

      var key = this.selectedImage.key;
      var subKey = this.selectedImage.subKey;
      var selected = this.media.find(function (image) {
        return image.id === _this.selectedImage.id;
      });

      if (subKey) {
        this.settings[key][subKey].id = selected.id;
        this.settings[key][subKey].src = selected.source_url;
        this.settings[key][subKey].width = selected.media_details.width;
        this.settings[key][subKey].height = selected.media_details.height;
      } else {
        this.settings[key].id = selected.id;
        this.settings[key].src = selected.source_url;
        this.settings[key].width = selected.media_details.width;
        this.settings[key].height = selected.media_details.height;
      }

      this.selectedImage.key = null;
      this.selectedImage.subKey = null;
      this.selectedImage.id = 0;
      this.dialogFormVisible = false;
    },
    /**
     * 更新ボタンをクリックしたらWPDBと同期する
     */
    submit: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ev) {
        var responseSettings, responseThemes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isRequesting = true;

                _context.next = 3;
                return this.$store.dispatch('wordpress/settings/update', this.settings);

              case 3:
                responseSettings = _context.sent;


                // navigation/sidebar/footerコンポーネントを更新する
                this.$children.forEach(function (child) {
                  if (!child.meta) return;
                  if (~['navigation', 'sidebar', 'footer'].indexOf(child.meta.type)) child.updateComponent();
                });

                _context.next = 7;
                return this.$store.dispatch('wordpress/themes/update', this.themes);

              case 7:
                responseThemes = _context.sent;


                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(responseSettings) === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.settings) && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(responseThemes) === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.themes)) {
                  this.$notify({
                    title: '更新完了',
                    message: 'サーバーデータを更新しました',
                    type: 'success',
                    duration: 1500
                  });
                } else {
                  this.$notify({
                    title: '更新失敗',
                    message: 'サーバーデータを更新できませんでした',
                    type: 'error',
                    duration: 1500
                  });
                }

                this.isRequesting = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit(_x) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  },
  created: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (false) console.log('On Settings created...');

              /**
               * navigationやfooterでpagesが必要になる
               * navigation/sidebar/footerコンポーネントが生成される前に
               * pagesを用意しておかないとrenderingできないため、requestThemesよりも
               * 前にpagesを取得しておく必要がある
               */
              this.isRequesting = true;
              _context2.prev = 2;
              _context2.next = 5;
              return this.requestMedia();

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](2);
              return _context2.abrupt('return', false);

            case 10:
              _context2.prev = 10;
              _context2.next = 13;
              return this.requestPages();

            case 13:
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t1 = _context2['catch'](10);
              return _context2.abrupt('return', false);

            case 18:
              _context2.prev = 18;
              _context2.next = 21;
              return this.requestSettings();

            case 21:
              _context2.next = 26;
              break;

            case 23:
              _context2.prev = 23;
              _context2.t2 = _context2['catch'](18);
              return _context2.abrupt('return', false);

            case 26:
              _context2.prev = 26;
              _context2.next = 29;
              return this.requestThemes();

            case 29:
              _context2.next = 34;
              break;

            case 31:
              _context2.prev = 31;
              _context2.t3 = _context2['catch'](26);
              return _context2.abrupt('return', false);

            case 34:
              this.isRequesting = false;
              this.isInitialized = true;

            case 36:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[2, 7], [10, 15], [18, 23], [26, 31]]);
    }));

    function created() {
      return _ref2.apply(this, arguments);
    }

    return created;
  }()
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(794);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f620402_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(854);
function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f620402"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f620402_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(853);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("71c021d8", content, true, {});

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".el-input[data-v-8f620402]{width:100%}.button-wrapper[data-v-8f620402]{margin-top:3em;text-align:center}.section-h3[data-v-8f620402]{border-left:4px solid #569cf3}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/routes/Settings.vue"],"names":[],"mappings":"AAsBA,2BACE,UAAY,CACb,AACD,iCACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,6BACE,6BAA+B,CAChC","file":"Settings.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.el-input[data-v-8f620402] {\n  width: 100%;\n}\n.button-wrapper[data-v-8f620402] {\n  margin-top: 3em;\n  text-align: center;\n}\n.section-h3[data-v-8f620402] {\n  border-left: 4px solid #569cf3;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(_vm.isRequesting),expression:"isRequesting",modifiers:{"fullscreen":true}}],attrs:{"element-loading-text":"サーバーに問い合わせています"}},[_c('section',{staticClass:"settings section app-section"},[_vm._m(0),_vm._v(" "),(_vm.isInitialized)?[_c('el-form',{staticClass:"p2",attrs:{"model":_vm.settings}},[_c('ul',{staticClass:"section-list p2"},[_vm._l((_vm.defaultSettings),function(setting,index){return [_c('li',{staticClass:"section-item pb2"},[_c('h3',{staticClass:"section-h3 pl1"},[_vm._v(_vm._s(setting.meta.heading))]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"section-p"},[_vm._v(_vm._s(setting.meta.description))]),_vm._v(" "),_vm._l((setting),function(item,key){return [(key !== 'meta' && typeof _vm.settings[index][key] !== 'undefined')?[(!item.type && !item.name && item.meta && item.meta.image)?[_c('h4',{staticClass:"section-h4"},[_vm._v(_vm._s(item.meta.heading))]),_vm._v(" "),_c('p',{staticClass:"section-p"},[_vm._v(_vm._s(item.meta.description))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.onSelectImage(index, key, _vm.settings[index][key])}}},[_vm._v("画像の選択")]),_vm._v(" "),_c('div',{staticClass:"image-info flex column justify-between items-center"},[_c('img',{staticClass:"image-info-img",attrs:{"src":_vm.settings[index][key]['src']}}),_vm._v(" "),_c('p',{staticClass:"image-info-size"},[_vm._v("画像のサイズ："+_vm._s(_vm.settings[index][key]['width'])+"x"+_vm._s(_vm.settings[index][key]['height']))])])]:_vm._e(),_vm._v(" "),(setting.meta && setting.meta.image)?[(key === 'src')?[_c('el-button',{on:{"click":function($event){_vm.onSelectImage(index, null, _vm.settings[index])}}},[_vm._v("画像の選択")]),_vm._v(" "),_c('div',{staticClass:"image-info flex column justify-between items-center"},[_c('img',{staticClass:"image-info-img",attrs:{"src":_vm.settings[index]['src']}}),_vm._v(" "),_c('p',{staticClass:"image-info-size"},[_vm._v("画像のサイズ："+_vm._s(_vm.settings[index]['width'])+"x"+_vm._s(_vm.settings[index]['height']))])])]:_vm._e()]:_vm._e(),_vm._v(" "),(setting.meta && !setting.meta.image)?[(item.type === 'number' || item.type === 'text')?_c('div',[_c('div',{staticClass:"stacked-label my1"},[_c('el-form-item',{attrs:{"label":item.name}},[_c('el-input',{attrs:{"type":item.type,"placeholder":item.default ? '例: ' + item.default : '例: ' + item.placeholder,"readonly":item.readonly},model:{value:(_vm.settings[index][key]),callback:function ($$v) {_vm.$set(_vm.settings[index], key, $$v)},expression:"settings[index][key]"}})],1)],1)]):_vm._e(),_vm._v(" "),(item.type === 'checkbox')?_c('div',[_c('h5',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_vm._l((item.values),function(checkbox,i){return [_c('el-checkbox',{key:i,attrs:{"label":checkbox.name},model:{value:(_vm.settings[index][key][i]),callback:function ($$v) {_vm.$set(_vm.settings[index][key], i, $$v)},expression:"settings[index][key][i]"}})]})],2):_vm._e()]:_vm._e()]:_vm._e()]})],2)])]}),_vm._v(" "),_c('div',{staticClass:"button-wrapper"},[_c('el-button',{staticClass:"primary raised round",attrs:{"type":"primary","loading":_vm.isRequesting},on:{"click":_vm.submit}},[_vm._v("更新")])],1)],2)])]:_vm._e()],2),_vm._v(" "),_c('section',[(_vm.themes)?[_vm._l((['navigation', 'sidebar', 'footer']),function(type){return [(_vm.themes[type] && _vm.themes[type].id)?[_c(_vm.getComponentNameById(_vm.themes[type].id),{tag:"div",attrs:{"component":_vm.themes[type],"hide-all":true,"preview-size":"native"}})]:_vm._e()]})]:_vm._e()],2),_vm._v(" "),_c('el-dialog',{attrs:{"width":"90%","title":"画像の選択","visible":_vm.dialogFormVisible},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('select-image',{on:{"change":_vm.onUpdateImage},model:{value:(_vm.selectedImage),callback:function ($$v) {_vm.selectedImage=$$v},expression:"selectedImage"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdateImage}},[_vm._v("選択")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":"50%","title":_vm.error.title,"visible":_vm.dialogErrorVisible},on:{"update:visible":function($event){_vm.dialogErrorVisible=$event}}},[_c('span',[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.dialogErrorVisible = false}}},[_vm._v("OK")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('h2',{staticClass:"app-h2"},[_vm._v("サイト設定")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.6d61fdba134b3f7173b2.js